module.exports = __webpack_public_path__ + "static/media/handbook.607cbadc.svg";